// Spanish error messages for validation
export const VALIDATION_ERRORS = {
  EMAIL_REQUIRED: 'El correo es requerido',
  EMAIL_INVALID: 'Formato de correo no válido',
  PASSWORD_REQUIRED: 'La contraseña es requerida',
  NAME_REQUIRED: 'El nombre es requerido',
  NAME_TOO_SHORT: 'El nombre debe tener al menos 2 caracteres',
  PASSWORDS_NO_MATCH: 'Las contraseñas deben coincidir'
};

// Validation functions that return error message or null
export const validateEmail = (email: string): string | null => {
  // RFC 5322 compliant regex - allows +, -, and modern TLDs of any length
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  if (!email || email.trim().length === 0) {
    return VALIDATION_ERRORS.EMAIL_REQUIRED;
  }

  if (!emailRegex.test(email)) {
    return VALIDATION_ERRORS.EMAIL_INVALID;
  }

  return null;
};

export const validatePassword = (password: string): string | null => {
  if (!password || password.length === 0) {
    return VALIDATION_ERRORS.PASSWORD_REQUIRED;
  }
  
  return null;
};

export const validateName = (name: string): string | null => {
  if (!name || name.trim().length === 0) {
    return VALIDATION_ERRORS.NAME_REQUIRED;
  }
  
  if (name.trim().length < 2) {
    return VALIDATION_ERRORS.NAME_TOO_SHORT;
  }
  
  return null;
};

export const validatePasswordMatch = (password: string, confirmPassword: string): string | null => {
  if (password !== confirmPassword) {
    return VALIDATION_ERRORS.PASSWORDS_NO_MATCH;
  }
  
  return null;
};

// Icon validation functions (for existing Login component compatibility)
export const getEmailValidationIcon = (email: string): string => {
  if (email.length === 0) return '';
  return validateEmail(email) ? 'alert' : 'done';
};

export const getPasswordValidationIcon = (password: string): string => {
  if (password.length === 0) return '';
  return validatePassword(password) ? 'alert' : 'done';
};

export const getNameValidationIcon = (name: string): string => {
  if (name.length === 0) return '';
  return validateName(name) ? 'alert' : 'done';
};

export const getPasswordMatchIcon = (password: string, confirmPassword: string): string => {
  if (confirmPassword.length === 0) return '';
  return validatePasswordMatch(password, confirmPassword) ? 'alert' : 'done';
};